module.exports = __webpack_public_path__ + "static/img/stairs-left_256.ab24a1b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stairs-left_256.png
// module id = bqoJ
// module chunks = 0